import { create } from "zustand";

export const useEmailStore = create((set) => ({
  showInstruction: false,
  setShowInstruction: () => set((state) => ({ showInstruction: !state.showInstruction })),
}));
